<template>
<div class='sendMessageWrap'>
<div class="pop" id="tip_message">
  <div class="messageWrapper">
      <div class="imgWrapper">
          <img src="../../assets/messageAlertInfo.png" class="messageImg"/>
      </div>
      <div class="messageContent">
          <div class="messageTitle">发送成功</div>
          <div class="messageCont">报告将以短信的方式发送给您</div>
          <div class="messageCont">请注意查收</div>
      </div>
      <div class="button_message" @click='goBack()'>返回</div>
  </div>
</div>
</div>
</template>
<script>
export default {
  name: 'commonDialog',
  props: [],
  data() {
    return {
      dialogImgSrc: ''
    }
  },
  created() {
  },
  methods: {
    goBack() {
      this.$emit('dialogGoBack', false)
    }
  }

}
</script>
<style lang='less' >
.sendMessageWrap{
  position: absolute;
.pop{
  position:fixed;
  width:100%;
  height:100%;
  left:0;
  top:0;
  background-color:rgba(0,0,0,.7)
}
.messageWrapper{
 width:5.6rem;
 height:6.69rem;
 background-color: #fff;
 position:absolute;
 left:50%;
 top:50%;
 margin-top: -3.345rem;
 margin-left:-2.8rem;
 border-radius: 0.3rem;
 z-index: 800;
}

.imgWrapper{
  width:100%;
  height: auto;
}
.messageImg{
  width:100%;
  height:auto;
}
.messageContent{
}
.messageTitle{
  text-align: center;
  color:#333;
  font-size: 0.36rem;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  line-height: 0.32rem;
  margin-top: 0.3rem;
  padding-bottom:0.16rem;
}
.messageCont{
  font-size:0.3rem;
  line-height: 0.6rem;
  color:#999;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  line-height: 0.45rem;
}
.button_message{
  background-color:#6498fe;
  line-height: 0.88rem;
  border-radius: 0.16rem;
  width:calc(100% - 0.72rem);
  margin-left: 0.36rem;
  margin-top: 0.34rem;
  font-size: 0.3rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
}
}
</style>



// WEBPACK FOOTER //
// src/components/sendMesssage/sendMessage.vue